module.exports = __webpack_public_path__ + "fonts/IGUIBetav9.7b0e692a.ttf";